import { InAppMessage, InAppMessageAction, InAppMessageActionType } from "../../core/internal/model/model"
import ObjectUtil from "../../core/internal/util/ObjectUtil"
import { HackleInAppMessage, HackleInAppMessageAction, HackleInAppMessageView } from "../../public/model"
import { InAppMessageView } from "./ui/view/InAppMessageView"

export class InAppMessageConverter {
  static toPublic(inAppMessage: InAppMessage): HackleInAppMessage {
    return {
      key: inAppMessage.key
    }
  }
}

export class InAppMessageViewConverter {
  static toPublic(view: InAppMessageView): HackleInAppMessageView {
    return {
      close: view.close.bind(view),
      inAppMessage: InAppMessageConverter.toPublic(view.context.inAppMessage)
    }
  }
}

const LINK_ACTION_TYPES: InAppMessageActionType[] = [
  "LINK_AND_CLOSE",
  "LINK_NEW_TAB",
  "LINK_NEW_TAB_AND_CLOSE",
  "LINK_NEW_WINDOW",
  "LINK_NEW_WINDOW_AND_CLOSE",
  "WEB_LINK"
]
const CLOSE_ACTION_TYPES: InAppMessageActionType[] = [
  "CLOSE",
  "HIDDEN",
  "LINK_AND_CLOSE",
  "LINK_NEW_TAB_AND_CLOSE",
  "LINK_NEW_WINDOW_AND_CLOSE"
]
const TAB_TARGET_ACTION_TYPES: InAppMessageActionType[] = ["LINK_NEW_TAB", "LINK_NEW_TAB_AND_CLOSE"]
const WINDOW_TARGET_ACTION_TYPES: InAppMessageActionType[] = ["LINK_NEW_WINDOW", "LINK_NEW_WINDOW_AND_CLOSE"]

export class InAppMessageActionConverter {
  static toPublic(action: InAppMessageAction): HackleInAppMessageAction {
    const actionType = action.type

    const isLink = LINK_ACTION_TYPES.some((t) => t === actionType)
    const isClose = CLOSE_ACTION_TYPES.some((t) => t === actionType)
    const isTab = TAB_TARGET_ACTION_TYPES.some((t) => t === actionType)
    const isWindow = WINDOW_TARGET_ACTION_TYPES.some((t) => t === actionType)
    return {
      type: isLink ? "LINK" : "CLOSE",
      close: isClose ? { hideDurationMillis: action.hideDurationMillis } : undefined,
      link: isLink
        ? {
            url: action.value ?? "",
            target: isWindow ? "NEW_WINDOW" : isTab ? "NEW_TAB" : "CURRENT",
            shouldCloseAfterLink: isClose
          }
        : undefined
    }
  }

  private static toInternalActionType(action: HackleInAppMessageAction): InAppMessageActionType {
    if (action.type === "CLOSE") {
      return ObjectUtil.isNotNullOrUndefined(action.close?.hideDurationMillis) ? "HIDDEN" : "CLOSE"
    }
    if (!action.link) {
      return "WEB_LINK"
    }
    if (action.link.target === "NEW_WINDOW") {
      return action.link.shouldCloseAfterLink ? "LINK_NEW_WINDOW_AND_CLOSE" : "LINK_NEW_WINDOW"
    }
    if (action.link.target === "NEW_TAB") {
      return action.link.shouldCloseAfterLink ? "LINK_NEW_TAB_AND_CLOSE" : "LINK_NEW_TAB"
    }
    return action.link.shouldCloseAfterLink ? "LINK_AND_CLOSE" : "WEB_LINK"
  }

  private static getActionValue(action: HackleInAppMessageAction): string | undefined {
    if (action.type === "LINK") {
      return action.link?.url
    }
    if (action.type === "CLOSE") {
      return action.close?.hideDurationMillis?.toString()
    }

    return undefined
  }

  static toInternal(action: HackleInAppMessageAction): InAppMessageAction {
    return new InAppMessageAction(
      "CLICK",
      InAppMessageActionConverter.toInternalActionType(action),
      InAppMessageActionConverter.getActionValue(action)
    )
  }
}
